import { Language } from '^/types';

export default {
  submit: {
    [Language.KO_KR]: '회원가입',
    [Language.EN_US]: 'SIGN UP',
  },
  createAccountSubmit: {
    [Language.KO_KR]: '계정 만들기',
    [Language.EN_US]: 'Create Account',
  },
  backButtonLabel: {
    [Language.KO_KR]: '로그인 페이지로 이동',
    [Language.EN_US]: 'Back to Sign in',
  },
  createAccount: {
    [Language.KO_KR]: '계정 만들기',
    [Language.EN_US]: 'Create an account',
  },
  setUpEmail: {
    [Language.KO_KR]: '이메일로 계정 설정하기',
    [Language.EN_US]: 'Set up your account with email',
  },
  signUpWithEmail: {
    [Language.KO_KR]: '이메일로 가입하기',
    [Language.EN_US]: 'Sign up with Email',
  },
  tellUsMoreAbout: {
    [Language.KO_KR]: '정보를 입력해주세요',
    [Language.EN_US]: 'Tell us more about you',
  },
  setYourPreference: {
    [Language.KO_KR]: '서비스 설정을 완료하세요',
    [Language.EN_US]: 'Set your preferences',
  },
  previous: {
    [Language.KO_KR]: '이전',
    [Language.EN_US]: 'Prev',
  },
  next: {
    [Language.KO_KR]: '다음',
    [Language.EN_US]: 'Next',
  },
  passwordSuggestionOne: {
    [Language.KO_KR]: '최소 6자',
    [Language.EN_US]: 'At least 6 characters',
  },
  passwordSuggestionTwo: {
    [Language.KO_KR]: '대문자, 소문자, 숫자를 포함해야 합니다',
    [Language.EN_US]: 'Must include uppercase, lowercase and number',
  },
  error: {
    email: {
      required: {
        [Language.KO_KR]: '필수 입력 사항입니다.',
        [Language.EN_US]: 'Required',
      },
      pattern: {
        [Language.KO_KR]: '이메일 형식을 확인하세요.',
        [Language.EN_US]: 'Please try again with a correct email address.',
      },
      existed: {
        [Language.KO_KR]: '이미 존재하는 계정입니다',
        [Language.EN_US]: 'The account already exists.',
      },
      error: {
        [Language.KO_KR]:
          '서버에서 에러가 발생했습니다. 반복해서 문제가 발생할 경우 고객센터로 연락주세요.',
        [Language.EN_US]:
          'Something went wrong in the server...' +
          'If the problem continues, please contact to our customer support',
      },
    },
    password: {
      required: {
        [Language.KO_KR]: '필수 입력 사항입니다.',
        [Language.EN_US]: 'Required',
      },
      minLength: {
        [Language.KO_KR]: '비밀번호는 6자 이상이어야 합니다.',
        [Language.EN_US]: 'Try one with at least 6 characters.',
      },
      maxLength: {
        [Language.KO_KR]: '비밀번호는 22자 이하여야 합니다.',
        [Language.EN_US]: 'Password should be less than 22 characters.',
      },
      pattern: {
        [Language.KO_KR]:
          '비밀번호에는 대문자, 소문자, 숫자 및 특수 기호(!@$%^&*+-_)가 포함되어야 합니다.',
        [Language.EN_US]:
          'Password should include capital letters, small letters, numbers and special symbols(!@$%^&*+-_).',
      },
      validCharacter: {
        [Language.KO_KR]:
          '비밀번호는 대문자, 소문자, 숫자, 간단한 기호(!@$%^&*+-_)만 포함할 수 있습니다.',
        [Language.EN_US]:
          'Password can only include capital letters, small letters, numbers, and simple symbols(!@$%^&*+-_).',
      },
    },
    passwordConfirmation: {
      required: {
        [Language.KO_KR]: '필수 입력 사항입니다.',
        [Language.EN_US]: 'Required',
      },
      equalPassword: {
        [Language.KO_KR]: '비밀번호가 같지 않습니다.',
        [Language.EN_US]: "These passwords don't match. Try again?",
      },
    },
    firstName: {
      required: {
        [Language.KO_KR]: '필수 입력 사항입니다.',
        [Language.EN_US]: 'Required',
      },
    },
    lastName: {
      required: {
        [Language.KO_KR]: '필수 입력 사항입니다.',
        [Language.EN_US]: 'Required',
      },
    },
    organization: {
      required: {
        [Language.KO_KR]: '필수 입력 사항입니다.',
        [Language.EN_US]: 'Required',
      },
    },
    contactNumber: {
      required: {
        [Language.KO_KR]: '필수 입력 사항입니다.',
        [Language.EN_US]: 'Required',
      },
      valid: {
        [Language.KO_KR]: '잘못된 연락처 번호',
        [Language.EN_US]: 'Invalid contact number.',
      },
    },
    country: {
      required: {
        [Language.KO_KR]: '필수 입력 사항입니다.',
        [Language.EN_US]: 'Required',
      },
    },
    purpose: {
      required: {
        [Language.KO_KR]: '필수 입력 사항입니다.',
        [Language.EN_US]: 'Required',
      },
    },
    language: {
      required: {
        [Language.KO_KR]: '필수 입력 사항입니다.',
        [Language.EN_US]: 'Required',
      },
    },
    eula: {
      required: {
        [Language.KO_KR]: '체크박스를 눌러 위의 내용에 동의해주세요.',
        [Language.EN_US]: 'Please agree with Terms and Conditions & Privacy Policy',
      },
    },
  },
  checkBoxLabelParts: [
    {
      [Language.EN_US]: 'By signing up, I agree to the ',
      [Language.KO_KR]: '서비스 ',
    },
    {
      [Language.EN_US]: 'Terms and Conditions',
      [Language.KO_KR]: '이용약관',
    },
    {
      [Language.EN_US]: ' & ',
      [Language.KO_KR]: ' 및 ',
    },
    {
      [Language.EN_US]: 'Privacy Policy',
      [Language.KO_KR]: '개인정보 처리방침',
    },
    {
      [Language.EN_US]: '.',
      [Language.KO_KR]: '에 동의합니다.',
    },
  ],
};
